import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Mail,
  Twitter,
  Instagram,
  Linkedin,
  Heart,
  BookOpen,
  Lightbulb,
  Users,
  Shield,
  ArrowUpRight,
  ChevronRight,
  MapPin,
  Globe
} from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

  return (
    <div className=" mx-auto px-4 sm:px-6 lg:px-8 bg-base-300">
      <div className="py-6 border-t border-base-300 flex flex-col md:flex-row justify-between items-center gap-4 bg-base-300">
        <div className="text-base-content/60 text-sm">
          © {currentYear} PathFinder. All rights reserved.
        </div>
        <div className="flex items-center">
          <span className="text-base-content/60 text-sm flex items-center">
            Made with <Heart size={14} className="mx-1 text-red-500" /> by
            <button
              onClick={() => navigate('/created-by')}
              className="ml-1 text-primary hover:text-primary-focus underline cursor-pointer bg-transparent border-none"
            >
              Ashwin S I
            </button>
          </span>
        </div>
      </div>
    </div>
  );
}